import { render } from "./InputGroup.vue?vue&type=template&id=2fe357a6&scoped=true&ts=true"
import script from "./InputGroup.vue?vue&type=script&lang=ts"
export * from "./InputGroup.vue?vue&type=script&lang=ts"

import "./input-group.scss?vue&type=style&index=0&id=2fe357a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe357a6"]])

export default __exports__